import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import MainPage from './dashboard/Dashboard';
import AnalyticsPage from './analytics/AnalyticsPage';
import BranchSettings from './business/BranchSettings';
import UpsertProduct from './product/UpsertProduct';
import UpsertProductVariant from './product/UpsertProductVariant';
import ProductIndexPage from './product/ProductIndexPage';
import ProductsPage from './product/ProductsPage';
import PreOrderProductsPage from './product/PreOrderProductsPage';
import UpdateBusiness from './business/UpdateBusiness';
import ReplenishPage from './replenish/ReplenishPage';
import OrdersPage from './orders/OrdersPage';
import OrdersDetailsIndexPage from './orders/OrdersDetailsIndexPage';
import OrderDetailPage from './orders/OrderDetailPage';
import CreateSoldOrderPage from './orders/CreateSoldOrderPage';
import CreateExpensePage from './orders/CreateExpensePage';
import CreateInvestmentPage from './orders/CreateInvestmentPage';
import PromotionsPage from './promotion/PromotionsPage';
import ChoosePromotionTypePage from './promotion/ChoosePromotionTypePage';
import CreatePromotionPage from './promotion/CreatePromotionPage';
import EditPromotionPage from './promotion/EditPromotionPage';
import CreateDiscountPromotionPage from './promotion/implementations/CreateDiscountPromotionPage';
import CreatePromoCodePromotionPage from './promotion/implementations/CreatePromoCodePromotionPage';
import CreateConditionalDiscountPromotionPage from './promotion/implementations/CreateConditionalDiscountPromotionPage';
import CreateCombinedDiscountPromotionPage from './promotion/implementations/CreateCombinedDiscountPromotionPage';
import CategoriesPage from './category/CategoriesPage';
import UpsertCategory from './category/UpsertCategory';
import CategoryProductsPage from './category/CategoryProductsPage';
import CategoryIndexPage from './category/CategoryIndexPage';
import ShipmentRecordsPage from './shipment/ShipmentRecordsPage';
import ShipmentsPage from './shipment/ShipmentsPage';
import UpsertShipment from './shipment/UpsertShipment';
import DebtsPage from './orders/debts/DebtsPage';
import PaymentsPage from './orders/payments/PaymentsPage';
import ReceiptsPage from './orders/receipts/ReceiptsPage';
import PaymentProvidersPage from './orders/payments/PaymentProvidersPage';
import PaymentProviderDetailsPage from './orders/payments/PaymentProviderDetailsPage';
import ReceiptProvidersPage from './orders/receipts/ReceiptProvidersPage';
import ReceiptProviderDetailsPage from './orders/receipts/ReceiptProviderDetailsPage';
import BannersPage from './banner/BannersPage';
import AddBannerPage from './banner/AddBannerPage';
import BannerIndexPage from './banner/BannerIndexPage';
import CustomOrderStatusesPage from './order-status/CustomOrderStatusesPage';
import UpsertCustomOrderStatus from './order-status/UpsertCustomOrderStatus';
import EmployeesPage from './employees/EmployeesPage';
import UpsertEmployee from './employees/UpsertEmployee';
import { BranchNavProvider } from '../hooks/branchNav.hook';

export default function ProviderRoutes() {
    return (
        <BranchNavProvider>
            <Routes>
            <Route index element={<Navigate to="/branch/store" replace />} />
            <Route path="branch" element={<Navigate to="/branch/store" replace />} />
            <Route path="branch/:branchId" element={<MainPage />} />
            <Route path="branch/:branchId/analytics" element={<AnalyticsPage />} />
            <Route path="branch/:branchId/products" element={<ProductsPage />} />
            <Route path="branch/:branchId/products/pre-order" element={<PreOrderProductsPage />} />
            <Route path="branch/:branchId/replenish" element={<ReplenishPage />} />
            <Route path="branch/:branchId/shipments" element={<ShipmentRecordsPage />} />
            <Route path="branch/:branchId/shipments/plans" element={<ShipmentsPage />} />
            <Route path="branch/:branchId/shipments/create" element={<UpsertShipment />} />
            <Route path="branch/:branchId/shipments/:shipmentId/edit" element={<UpsertShipment />} />
            <Route path="branch/:branchId/debts" element={<DebtsPage />} />
            <Route path="branch/:branchId/payments" element={<PaymentsPage />} />
            <Route path="branch/:branchId/receipts" element={<ReceiptsPage />} />
            <Route path="branch/:branchId/payment-providers" element={<PaymentProvidersPage />} />
            <Route path="branch/:branchId/payment-providers/o-trade" element={<PaymentProviderDetailsPage />} />
            <Route path="branch/:branchId/receipt-providers" element={<ReceiptProvidersPage />} />
            <Route path="branch/:branchId/receipt-providers/ekassa" element={<ReceiptProviderDetailsPage />} />
            <Route path="branch/:branchId/orders" element={<OrdersPage />} />
            <Route path="branch/:branchId/orders/create" element={<CreateSoldOrderPage />} />
            <Route path="branch/:branchId/orders/expense" element={<CreateExpensePage />} />
            <Route path="branch/:branchId/orders/investment" element={<CreateInvestmentPage />} />
            <Route path="branch/:branchId/orders/columns" element={<OrdersDetailsIndexPage />} />
            <Route path="branch/:branchId/orders/:orderId" element={<OrderDetailPage />} />

            <Route path="business/update" element={<UpdateBusiness />} />
            <Route path="business/branch-settings" element={<BranchSettings />} />
            <Route path="business/branch/create" element={<BranchSettings mode="create" />} />
            <Route path="business/branch/:branchId/edit" element={<BranchSettings mode="edit" />} />

            <Route path="product/create" element={<UpsertProduct />} />
            <Route path="product/:productId/edit" element={<UpsertProduct />} />
            <Route path="product/:productId/variant/create" element={<UpsertProductVariant />} />
            <Route path="product/:productId/variant/:variantId/edit" element={<UpsertProductVariant />} />
            <Route path="products/index" element={<ProductIndexPage />} />

            <Route path="promotions" element={<PromotionsPage />} />
            <Route path="promotions/choose" element={<ChoosePromotionTypePage />} />
            <Route path="promotions/create" element={<CreatePromotionPage />} />
            <Route path="promotions/:promotionId/edit" element={<EditPromotionPage />} />
            <Route path="promotions/:promotionId/edit/discount" element={<CreateDiscountPromotionPage />} />
            <Route path="promotions/:promotionId/edit/promo-code" element={<CreatePromoCodePromotionPage />} />
            <Route path="promotions/:promotionId/edit/conditional" element={<CreateConditionalDiscountPromotionPage />} />
            <Route path="promotions/:promotionId/edit/combined" element={<CreateCombinedDiscountPromotionPage />} />
            <Route path="promotions/:promotionId/edit/conditional-discount" element={<CreateConditionalDiscountPromotionPage />} />
            <Route path="promotions/:promotionId/edit/combined-discount" element={<CreateCombinedDiscountPromotionPage />} />

            <Route path="banners" element={<BannersPage />} />
            <Route path="banners/create" element={<AddBannerPage />} />
            <Route path="banners/index" element={<BannerIndexPage />} />

            <Route path="order-statuses" element={<CustomOrderStatusesPage />} />
            <Route path="order-statuses/create" element={<UpsertCustomOrderStatus />} />
            <Route path="order-statuses/:customOrderStatusId/edit" element={<UpsertCustomOrderStatus />} />

            <Route path="categories" element={<CategoriesPage />} />
            <Route path="categories/create" element={<UpsertCategory />} />
            <Route path="categories/index" element={<CategoryIndexPage />} />
            <Route path="categories/:categoryId/edit" element={<UpsertCategory />} />
            <Route path="categories/:categoryId/products" element={<CategoryProductsPage />} />

            <Route path="employees" element={<EmployeesPage />} />
            <Route path="employees/create" element={<UpsertEmployee />} />
            <Route path="employees/:employeeId/edit" element={<UpsertEmployee />} />

            {/* fallback */}
            <Route path="*" element={<Navigate to="/branch/store" replace />} />
            </Routes>
        </BranchNavProvider>
    );
}

